import { Record } from 'immutable';
const CategoryOrganizationBufferedChangesRecord = Record({
  error: undefined,
  hasBufferedChanges: false,
  hasLocalChanges: false,
  isRequesting: false,
  lastLoaded: undefined
});
export default CategoryOrganizationBufferedChangesRecord;